import { useMemo, useState } from "react";

export function useFilteredList<T>(
  items: T[],
  predicate: (item: T, query: string) => boolean
) {
  const [search, setSearch] = useState("");
  const filtered = useMemo(
    () => items.filter((item) => predicate(item, search.toLowerCase().trim())),
    [items, search, predicate]
  );
  return { filtered, search, setSearch };
}
